import makeRequest from "../../../makeRequest";

const url = "/api/user/appointment";

export async function createAppointment(
  data: any,
  headers?: Record<string, string>
) {
  return makeRequest("PUT", url, data, headers);
}

export async function modifyAppointment(
  data: any,
  headers?: Record<string, string>
) {
  return makeRequest("POST", url, data, { ...headers });
}

export async function getAppointment(
  appointmentId: string,
  headers?: Record<string, string>
) {
  return makeRequest("GET", `${url}/${appointmentId}`, undefined, {
    ...headers,
  });
}

export async function cancelAppointment(
  appointmentId: string,
  headers?: Record<string, string>
) {
  return makeRequest("POST", `${url}/${appointmentId}/cancel`, undefined, {
    ...headers,
  });
}
